import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    partyName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    startTime: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    endTime: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    category: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    siteName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    description: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Requester Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'E-Mail *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone *',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Event Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Title *',
            mapping: 'partyName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Start Time *',
            options: [
              { label: '07:00 AM' , value: '07:00:00' },
              { label: '07:15 AM' , value: '07:15:00' },
              { label: '07:30 AM' , value: '07:30:00' },
              { label: '07:45 AM' , value: '07:45:00' },
              { label: '08:00 AM' , value: '08:00:00' },
              { label: '08:15 AM' , value: '08:15:00' },
              { label: '08:30 AM' , value: '08:30:00' },
              { label: '08:45 AM' , value: '08:45:00' },
              { label: '09:00 AM' , value: '09:00:00' },
              { label: '09:15 AM' , value: '09:15:00' },
              { label: '09:30 AM' , value: '09:30:00' },
              { label: '09:45 AM' , value: '09:45:00' },
              { label: '10:00 AM' , value: '10:00:00' },
              { label: '10:15 AM' , value: '10:15:00' },
              { label: '10:30 AM' , value: '10:30:00' },
              { label: '10:45 AM' , value: '10:45:00' },
              { label: '11:00 AM' , value: '11:00:00' },
              { label: '11:15 AM' , value: '11:15:00' },
              { label: '11:30 AM' , value: '11:30:00' },
              { label: '11:45 AM' , value: '11:45:00' },
              { label: '12:00 PM' , value: '12:00:00' },
              { label: '12:15 PM' , value: '12:15:00' },
              { label: '12:30 PM' , value: '12:30:00' },
              { label: '12:45 PM' , value: '12:45:00' },
              { label: '1:00 PM' , value: '13:00:00' },
              { label: '1:15 PM' , value: '13:15:00' },
              { label: '1:30 PM' , value: '13:30:00' },
              { label: '1:45 PM' , value: '13:45:00' },
              { label: '2:00 PM' , value: '14:00:00' },
              { label: '2:15 PM' , value: '14:15:00' },
              { label: '2:30 PM' , value: '14:30:00' },
              { label: '2:45 PM' , value: '14:45:00' },
              { label: '3:00 PM' , value: '15:00:00' },
              { label: '3:15 PM' , value: '15:15:00' },
              { label: '3:30 PM' , value: '15:30:00' },
              { label: '3:45 PM' , value: '15:45:00' },
              { label: '4:00 PM' , value: '16:00:00' },
              { label: '4:15 PM' , value: '16:15:00' },
              { label: '4:30 PM' , value: '16:30:00' },
              { label: '4:45 PM' , value: '16:45:00' },
              { label: '5:00 PM' , value: '17:00:00' },
              { label: '5:15 PM' , value: '17:15:00' },
              { label: '5:30 PM' , value: '17:30:00' },
              { label: '5:45 PM' , value: '17:45:00' },
              { label: '6:00 PM' , value: '18:00:00' },
              { label: '6:15 PM' , value: '18:15:00' },
              { label: '6:30 PM' , value: '18:30:00' },
              { label: '6:45 PM' , value: '18:45:00' },
              { label: '7:00 PM' , value: '19:00:00' },
              { label: '7:15 PM' , value: '19:15:00' },
              { label: '7:30 PM' , value: '19:30:00' },
              { label: '7:45 PM' , value: '19:45:00' },
              { label: '8:00 PM' , value: '20:00:00' },
              { label: '8:15 PM' , value: '20:15:00' },
              { label: '8:30 PM' , value: '20:30:00' },
              { label: '8:45 PM' , value: '20:45:00' },
              { label: '9:00 PM' , value: '21:00:00' },
              { label: '9:15 PM' , value: '21:15:00' },
              { label: '9:30 PM' , value: '21:30:00' },
              { label: '9:45 PM' , value: '21:45:00' }
            ],
            mapping: 'startTime'
          }
        ]
      },
      {
        fields: [ 
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event End Time *',
            options: [
              { label: '07:00 AM' , value: '07:00:00' },
              { label: '07:15 AM' , value: '07:15:00' },
              { label: '07:30 AM' , value: '07:30:00' },
              { label: '07:45 AM' , value: '07:45:00' },
              { label: '08:00 AM' , value: '08:00:00' },
              { label: '08:15 AM' , value: '08:15:00' },
              { label: '08:30 AM' , value: '08:30:00' },
              { label: '08:45 AM' , value: '08:45:00' },
              { label: '09:00 AM' , value: '09:00:00' },
              { label: '09:15 AM' , value: '09:15:00' },
              { label: '09:30 AM' , value: '09:30:00' },
              { label: '09:45 AM' , value: '09:45:00' },
              { label: '10:00 AM' , value: '10:00:00' },
              { label: '10:15 AM' , value: '10:15:00' },
              { label: '10:30 AM' , value: '10:30:00' },
              { label: '10:45 AM' , value: '10:45:00' },
              { label: '11:00 AM' , value: '11:00:00' },
              { label: '11:15 AM' , value: '11:15:00' },
              { label: '11:30 AM' , value: '11:30:00' },
              { label: '11:45 AM' , value: '11:45:00' },
              { label: '12:00 PM' , value: '12:00:00' },
              { label: '12:15 PM' , value: '12:15:00' },
              { label: '12:30 PM' , value: '12:30:00' },
              { label: '12:45 PM' , value: '12:45:00' },
              { label: '1:00 PM' , value: '13:00:00' },
              { label: '1:15 PM' , value: '13:15:00' },
              { label: '1:30 PM' , value: '13:30:00' },
              { label: '1:45 PM' , value: '13:45:00' },
              { label: '2:00 PM' , value: '14:00:00' },
              { label: '2:15 PM' , value: '14:15:00' },
              { label: '2:30 PM' , value: '14:30:00' },
              { label: '2:45 PM' , value: '14:45:00' },
              { label: '3:00 PM' , value: '15:00:00' },
              { label: '3:15 PM' , value: '15:15:00' },
              { label: '3:30 PM' , value: '15:30:00' },
              { label: '3:45 PM' , value: '15:45:00' },
              { label: '4:00 PM' , value: '16:00:00' },
              { label: '4:15 PM' , value: '16:15:00' },
              { label: '4:30 PM' , value: '16:30:00' },
              { label: '4:45 PM' , value: '16:45:00' },
              { label: '5:00 PM' , value: '17:00:00' },
              { label: '5:15 PM' , value: '17:15:00' },
              { label: '5:30 PM' , value: '17:30:00' },
              { label: '5:45 PM' , value: '17:45:00' },
              { label: '6:00 PM' , value: '18:00:00' },
              { label: '6:15 PM' , value: '18:15:00' },
              { label: '6:30 PM' , value: '18:30:00' },
              { label: '6:45 PM' , value: '18:45:00' },
              { label: '7:00 PM' , value: '19:00:00' },
              { label: '7:15 PM' , value: '19:15:00' },
              { label: '7:30 PM' , value: '19:30:00' },
              { label: '7:45 PM' , value: '19:45:00' },
              { label: '8:00 PM' , value: '20:00:00' },
              { label: '8:15 PM' , value: '20:15:00' },
              { label: '8:30 PM' , value: '20:30:00' },
              { label: '8:45 PM' , value: '20:45:00' },
              { label: '9:00 PM' , value: '21:00:00' },
              { label: '9:15 PM' , value: '21:15:00' },
              { label: '9:30 PM' , value: '21:30:00' },
              { label: '9:45 PM' , value: '21:45:00' },
              { label: '10:00 PM' , value: '22:00:00' },
              { label: '10:15 PM' , value: '22:15:00' },
              { label: '10:30 PM' , value: '22:30:00' },
              { label: '10:45 PM' , value: '22:45:00' },
              { label: '11:00 PM' , value: '23:00:00' }
            ],
            mapping: 'endTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests *',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Request Type *',
            options: [
              { label: 'Catered' , value: 'Catered' },
              { label: 'Delivery', value: 'Delivery' },
              { label: 'Pick-Up' , value: 'Pick-Up' }
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Room Requested *',
            options: [
              { label: 'Crowell 6 Board Room' , value: 'Crowell 6 Board Room' },
              { label: 'Crowell 9 Board Room', value: 'Crowell 9 Board Room' },
              { label: 'Crowell 9 Small Conf. Room' , value: 'Crowell 9 Small Conf. Room' },
              { label: 'Kimball Room' , value: 'Kimball Room' },
              { label: 'Sankey Room', value: 'Sankey Room' },
              { label: 'Varley Room' , value: 'Varley Room' },
              { label: 'Other' , value: 'Other' }
            ],
            mapping: 'siteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type *',
            options: [
              { label: 'A la Carte' , value: 'A la Carte' },
              { label: 'Buffet: Breakfast', value: 'Buffet: Breakfast' },
              { label: 'Buffet: Lunch' , value: 'Buffet: Lunch' },
              { label: 'Buffet: Dinner' , value: 'Buffet: Dinner' },
              { label: 'Coffee Break', value: 'Coffee Break' },
              { label: 'Reception' , value: 'Reception' },
              { label: 'Served Breakfast' , value: 'Served Breakfast' },
              { label: 'Served Lunch' , value: 'Served Lunch' },
              { label: 'Served Dinner' , value: 'Served Dinner' },
              { label: 'Delivery: Boxed Meal' , value: 'Delivery: Boxed Meal' },
              { label: 'Pick-Up: Boxed Meal' , value: 'Pick-Up: Boxed Meal' }
            ],
            mapping: 'description'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Comments / Additional Requests:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit this Form'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Moody Bible Institute Contact Form',
    formId: '489',
    clientKey: 'A1A7EC55-EEC1-4F10-A857-20AC5CEEBA27',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/moodybibleinst/form_structure.js